<!--
 * @Author: your name
 * @Date: 2021-06-22 15:56:41
 * @LastEditTime: 2021-08-30 14:33:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\views\home\layout\Logo.vue
 <ec-svg-icon icon-class="icon-east-logo" class="sidebar-logo" style="width: 165px; height: 40px"/>
-->
<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <div v-if="collapse" key="collapse" class="sidebar-logo-link" style="width: 72px">
        <ec-svg-icon icon-class="icon-logo-east-h" class="sidebar-logo" style="width: 40px"/>
      </div>
      <div v-else key="expand" class="sidebar-logo-link" style="width: 200px">
        <ec-svg-icon icon-class="icon-logo-east" class="sidebar-logo" style="width: 178px"/>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  transition: width 1.5s;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  height: 50px;
  line-height: 50px;
  text-align: center;
  overflow: hidden;
  // background: rgb(0, 96, 164);
  & .sidebar-logo-link {
    height: 100%;
    display: inline-block;

    & .sidebar-logo {
      width: 178px;
      height: 30px;
      vertical-align: middle;
      margin-right: 4px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 16px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/layout/Logo.vue